var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceendpointsmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.488 55.568L15.832 34.056C14.896 33.624 13.328 32.8 10.832 34.056C9.39997 34.776 10.256 36.256 10.832 36.568L50.36 59.648C51.192 60.064 53.24 60.528 54.736 59.016C56.24 57.512 54.528 56.088 53.488 55.56V55.568Z",
    fill: "url(#paint0_linear_3890_386570)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3361 43.696C55.3361 40.432 53.0481 36.488 50.2321 34.864C49.6961 34.552 49.104 34.328 48.4801 34.216C47.8001 30.584 45.5281 26.744 42.6881 24.424C42.6721 24.408 42.6481 24.384 42.6321 24.368C42.5361 24.296 42.4481 24.224 42.3521 24.144L42.2401 24.072L41.9841 23.888L41.8721 23.816L41.6161 23.648L41.5041 23.576C41.3761 23.504 41.2641 23.432 41.1361 23.352C41.0081 23.28 40.8961 23.208 40.7681 23.152L40.7281 23.136C40.6161 23.08 40.5041 23.024 40.4001 22.968L40.3281 22.928C39.6481 22.6 38.9121 22.408 38.1361 22.336C37.7121 17.744 34.8321 12.6 31.1441 9.74398C31.0321 9.64798 30.9041 9.55998 30.7921 9.48798C30.6801 9.41598 30.5521 9.31998 30.4401 9.24798L30.3441 9.19198C30.2481 9.13598 30.1601 9.06398 30.0641 9.00798C29.9361 8.93598 29.8081 8.83998 29.6801 8.76798C29.5521 8.69598 29.4241 8.62398 29.3121 8.56798L29.2001 8.51198C29.1281 8.47198 29.0561 8.43998 28.9601 8.39998L28.8641 8.34398L28.7681 8.30398C28.6961 8.26398 28.6401 8.24798 28.5681 8.20798L28.4561 8.15198C28.4001 8.13598 28.3441 8.11198 28.2881 8.09598L28.2161 8.05598L28.0481 7.98398L27.8641 7.92798L27.6641 7.87198L27.4801 7.83198C27.4081 7.81598 27.3521 7.79198 27.2801 7.77598L27.0961 7.73598L26.8961 7.67998L26.7281 7.63998L26.5441 7.62398C26.4881 7.62398 26.4321 7.60798 26.3761 7.60798L26.1921 7.59198H25.6561C25.6001 7.59198 25.5281 7.59198 25.4721 7.60798L25.3281 7.62398C25.2721 7.62398 25.2001 7.63998 25.1441 7.63998L25.0001 7.65598C24.9441 7.67198 24.8721 7.67198 24.8161 7.69598L24.6881 7.73598C24.6321 7.75198 24.5601 7.77598 24.5041 7.79198C24.4481 7.80798 24.4321 7.80798 24.3761 7.83198C24.3041 7.84798 24.2481 7.88798 24.1761 7.90398C24.1361 7.91998 24.1041 7.91998 24.0801 7.94398C23.9841 7.98398 23.8961 8.03998 23.8001 8.07198L23.7281 8.11198L23.6161 8.18398L18.8561 11.008L20.4401 12.264C20.3681 12.304 20.2961 12.336 20.2001 12.376H20.1841L12.1281 17.008L15.2641 18.448L18.1601 17.56C18.4721 21.728 21.3841 26.544 24.9281 28.584L48.1041 45.128L48.8241 49.944L53.8401 46.992H53.8561L53.8961 46.976C54.7601 46.424 55.3361 45.296 55.3361 43.696Z",
    fill: "url(#paint1_linear_3890_386570)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.232 37.792C44.696 37.48 44.104 37.256 43.48 37.144C42.672 32.864 39.696 28.328 36.16 26.28C35.088 25.672 34.08 25.336 33.152 25.264C32.672 20.08 29.08 14.2 24.704 11.672C20 8.96002 16.184 11.152 16.184 16.592C16.184 16.776 16.184 16.96 16.2 17.144C12.768 15.56 10.08 17.344 10.08 21.424C10.08 25.76 13.12 31.032 16.888 33.192L45.248 49.568C48.072 51.192 50.352 49.88 50.352 46.616C50.352 43.352 48.048 39.408 45.224 37.784L45.232 37.792Z",
    fill: "url(#paint2_linear_3890_386570)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40805 17.672L5.02405 20.416L20.704 29.376L20.976 25.472L7.40805 17.672Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7422 34.9743C29.8314 33.7681 29.8702 29.9242 27.829 26.3886C25.7877 22.8531 22.4394 20.9648 20.3502 22.171C18.261 23.3772 18.2221 27.2211 20.2634 30.7566C22.3046 34.2922 25.653 36.1805 27.7422 34.9743Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3890_386570",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 25,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.112 22.496C21.608 21.08 19.488 21.904 18.92 24.288L10.36 19.36C10.536 18.776 10.96 17.784 11.952 17.112V16.656L11.064 16.336L7.77598 17.872L7.41598 17.664L5.03198 20.408L19.288 28.552C20.128 31.048 21.912 33.448 24 34.624C26.92 36.272 29.312 34.888 29.344 31.536C29.376 28.184 27.04 24.128 24.12 22.48L24.112 22.496Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3890_386570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7679 23.416L11.1359 16.648L7.91992 18.504L19.5439 25.272L22.7679 23.416Z",
    fill: "#BCBCBC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3890_386570",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 12,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7422 34.9742C29.8314 33.7681 29.8702 29.9241 27.829 26.3886C25.7877 22.853 22.4394 20.9647 20.3502 22.1709C18.261 23.3771 18.2221 27.221 20.2634 30.7566C22.3046 34.2921 25.653 36.1804 27.7422 34.9742Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3890_386570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5279 29.92C30.5279 27.096 28.5439 23.656 26.0959 22.248C24.8559 21.536 23.7439 21.472 22.9359 21.952L20.8159 23.176L21.6639 24.696C21.6639 24.696 21.6639 24.768 21.6639 24.8C21.6639 27.584 23.5919 30.952 25.9839 32.408L26.9359 34.112L29.2079 32.8C30.0239 32.344 30.5199 31.344 30.5199 29.92H30.5279Z",
    fill: "url(#paint3_linear_3890_386570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9199 24.288L23.16 21.824L21.6639 20.936L17.6479 22.76L18.9199 24.288Z",
    fill: "#DCDCDC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.992 23.464C21.776 22.184 19.928 23 19.592 25.256L18.832 24.816L7.92004 18.504V21.48L19.944 28.432C20.656 30.6 22.2 32.712 23.984 33.76C26.44 35.176 28.44 34.016 28.44 31.184C28.44 28.352 26.44 24.88 23.984 23.464H23.992Z",
    fill: "#A0A0A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3890_386570",
    x1: 54.824,
    y1: 59.488,
    x2: 11.408,
    y2: 33.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3890_386570",
    x1: 17.1041,
    y1: 7.83198,
    x2: 51.5041,
    y2: 48.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3890_386570",
    x1: 10.088,
    y1: 30.4,
    x2: 50.36,
    y2: 30.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3890_386570",
    x1: 22.9759,
    y1: 31.824,
    x2: 27.9039,
    y2: 23.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceendpointsmall);
export default __webpack_public_path__ + "static/media/service endpoint small.538c4397ef153342a123bb4afddbb31a.svg";
export { ForwardRef as ReactComponent };